<template>
  <div>
    <AsyncModal
      :fetch="fetchExcludedAccessories"
      :name="MODAL_NAMES.EXCLUDED_ACCESSORIES"
      :title="modalTitle"
    >
      <template #content>
        <div v-for="row in excludedAccessories" :key="row.title" class="mb-24">
          <ContentRow headingTag="h3" :labels="row.labels" :title="row.title">
            <component :is="row.icon" aria-hidden="true"></component>
          </ContentRow>
        </div>
      </template>
    </AsyncModal>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import AsyncModal from '@backmarket/nuxt-layer-product-modals/AsyncModal.vue'
import ContentRow from '@backmarket/nuxt-layer-product-modals/ContentRow.vue'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { IconChargingWire as DSIconChargingWire } from '@ds/icons/IconChargingWire'
import { IconQuality as DSIconQuality } from '@ds/icons/IconQuality'
import { IconWarning as DSIconWarning } from '@ds/icons/IconWarning'

import type { GetAccessoryExclusionsResponse } from '~/api/product-page/types'
import { MODAL_NAMES } from '~/scopes/product/constants'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

const ICONS: Record<string, unknown> = {
  IconChargingWire: DSIconChargingWire,
  IconQuality: DSIconQuality,
  IconWarning: DSIconWarning,
}

const $httpFetch = useHttpFetch()
const { productId } = useUrlParams()
const requestParams = { pathParams: { productId } }
const accessories = ref()

const modalTitle = computed(() => accessories.value?.title ?? '')
const excludedAccessories = computed(() => {
  return (accessories.value?.paragraphs ?? []).map(
    ({
      icon,
      title,
      text,
    }: GetAccessoryExclusionsResponse['paragraphs'][number]) => ({
      icon: ICONS[icon],
      labels: [text],
      title,
    }),
  )
})

async function fetchExcludedAccessories() {
  try {
    const data = await $httpFetch(
      '/product-page/products/:productId/accessory-exclusions',
      { ...requestParams },
    )

    accessories.value = { ...data }
  } catch {
    // Do nothing
  }
}
</script>
